export enum OnboardingWidgetDateRangeEnum {
    Last1Day = 1,
    Last1DayDescription = 'Last 1 Day',
    Last3Days = 2,
    Last3DaysDescription = 'Last 3 Days',
    Last7Days = 3,
    Last7DaysDescription = 'Last 7 Days',
    ThisWeek = 4,
    ThisWeekDescription = 'This Week',
    LastWeek = 5,
    LastWeekDescription = 'Last Week',
    ThisMonth = 6,
    ThisMonthDescription = 'This Month',
    LastMonth = 7,
    LastMonthDescription = 'Last Month',
    Custom = 8,
    CustomDescription = 'Custom',
}
